/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import { submitNewPassword } from './service/calls';
import { Logo } from '../components/App/Header/Logo';
import { alertActions } from '../actions/Alerts';
import { validation } from './service/validations';
import FooterInfo from './FooterInfo';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(30),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    marginTop: theme.spacing(2),
  },
  item: {
    paddingTop: '1em',
  },
  root: {
    fontSize: '1em',
  },
  all: {
    height: '100%',
  },
}));

export const ResetPassword = ({ history }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [inputs, setInputs] = useState({
    userId: '',
    resetPasswordToken: '',
    password: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const { password } = inputs;
  const dispatch = useDispatch();

  // reset login status
  useEffect(() => {
    const url = new URL(window.location.href);
    const userId = url.searchParams.get('uid');
    const resetPasswordToken = url.searchParams.get('rpt');

    setInputs({
      userId,
      resetPasswordToken,
      password: '',
    });

    dispatch(alertActions.clear());
  }, []);

  useEffect(() => {
    if (submitted && !errors.password) {
      submitNewPassword(inputs).then(() => {
        setTimeout(() => history.push('/'), 10000);
        // setSubmitted(false);
      });
    }
  }, [submitted]);

  function handleChange(e) {
    const { name, value } = e.target;
    setErrors({});
    setInputs({ ...inputs, [name]: value });
  }

  const handleClickShowPassword = () => {
    setInputs({ ...inputs, showPassword: !inputs.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  function handleSubmit(e) {
    e.preventDefault();
    const err = validation({ password });
    setErrors(err);

    if (!err.password && password) {
    setSubmitted(true);
    }
  }

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      justifyContent="space-between"
      alignItems="center"
      className={classes.all}
    >
      >
      <Logo />
      <Container maxWidth="xs">
        <div className={classes.paper}>
          {submitted ? (
            <Grid
              container
              alignContent="center"
            >
              <Typography
                color="secondary"
                align="center"
                component="h1"
                variant="h6"
              >
                {t('auth.resetpasswordinfo')}
              </Typography>
            </Grid>
          ) : (
            <>
              <Typography color="secondary" align="left" component="h1" variant="h4">
                Type your new password
              </Typography>
              <form className={classes.form} onSubmit={handleSubmit}>
                {/* PASSWORD */}
                <Grid item xs={12} className={classes.item}>
                  <InputLabel>{t('auth.passwordinput')}</InputLabel>
                  <TextField
                // autoComplete="new"
                    name="password"
                    type={inputs.showPassword ? 'text' : 'password'}
                    fullWidth
                    variant="outlined"
                    required
                    error={!!errors.password}
                    defaultValue={inputs.password}
                    onChange={handleChange}
                    autoFocus
                    InputProps={{
                      autoComplete: 'new-password',
                      form: {
                        autoComplete: 'off',
                      },
                      endAdornment: (
                      // eslint-disable-next-line react/jsx-wrap-multilines
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {inputs.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <FormHelperText className={classes.root} error={!!errors.password}>
                    {errors.password && errors.password}
                  </FormHelperText>
                </Grid>
                <Grid item xs={12}>
                  <Button className={classes.submit} type="submit" fullWidth variant="outlined" size="large" onClick={(e) => handleSubmit(e)} disabled={!!errors.password}>
                    Send
                  </Button>
                </Grid>
              </form>
            </>
          )}
          <Box mt={5}>
            <Link to="/">
              Login
            </Link>
          </Box>
        </div>
      </Container>
      <FooterInfo />
    </Grid>
  );
};
